;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { hasStringProperty } from '@qogita/validation/object'
import type {
  ErrorOption,
  FieldErrors,
  FieldPath,
  FieldValues,
  UseFormSetError,
} from 'react-hook-form'

function isFieldPath<TFieldValues extends FieldValues>(
  field: string,
  errors: FieldErrors<TFieldValues>,
): field is FieldPath<TFieldValues> | 'root' {
  return field in errors
}

function isSettableFieldError(value: unknown): value is ErrorOption {
  return hasStringProperty(value, 'message')
}

export function applyFieldErrors<TFieldValues extends FieldValues>(
  setError: UseFormSetError<TFieldValues>,
  errors: FieldErrors<TFieldValues>,
): void {
  for (const field of Object.keys(errors)) {
    if (!isFieldPath(field, errors)) {
      continue
    }

    const value = errors[field]
    if (!isSettableFieldError(value)) {
      continue
    }

    setError(field, value)
  }
}
